exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dismiss-animation__revealExpandStart__1VXgd{max-height:0;opacity:.01;transition-property:opacity,max-height;transition-duration:.15s;transition-timing-function:ease-out,linear}.dismiss-animation__revealExpandEnd__3NdPJ{max-height:300px;opacity:1}.dismiss-animation__fadeCollapseStart__b6oU-{max-height:300px;opacity:1;transition-property:opacity,max-height;transition-duration:.2s;transition-timing-function:ease-out,linear}.dismiss-animation__fadeCollapseEnd__23I4g{max-height:0;opacity:.01}", ""]);

// exports
exports.locals = {
	"revealExpandStart": "dismiss-animation__revealExpandStart__1VXgd",
	"revealExpandEnd": "dismiss-animation__revealExpandEnd__3NdPJ",
	"fadeCollapseStart": "dismiss-animation__fadeCollapseStart__b6oU-",
	"fadeCollapseEnd": "dismiss-animation__fadeCollapseEnd__23I4g"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2445/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/dismiss-animation.less
// module id = kP4B
// module chunks = 12